import type { ServiceCategoryEntity } from '../service-categories/service-category.entity'
import type { ServiceNested } from './service-nested'
import type { ServiceConsumptionItem } from './service-consumption-item'

export class Service {
    serviceId: string
    companyId: string
    name: string
    duration: number
    price: number
    costs: number
    comissionFixed: number
    comissionPercentage: number
    comissionFixedAttendant: number
    comissionPercentageAttendant: number
    comissionCosts: number
    comissionCostsAttendant: number
    status: number
    createdAt: string | Date
    updatedAt: string | Date
    consulting: boolean
    balance: boolean
    type: 'package' | 'service' | 'product' | 'consumable'
    stock: number
    avgCost?: number // custo médio ponderado, calculado pelo backend (ledger) — somente leitura
    minStock?: number
    nextExpirationDate: Date
    public: boolean
    scheduleInterval: number
    schedulers: string[]
    schedulersOnline: string[]
    documents: string[]
    description: string
    needResource: boolean
    generatesConsumption?: boolean // este serviço (type=service) consome insumos — controla a seção de receita
    // no cadastro e o preenchimento automático de consumo na agenda
    services?: ServiceNested[]
    consumptionRecipe?: ServiceConsumptionItem[] // receita (BOM): insumos e quantidades consumidos por este serviço
    expirationDays: number
    serviceCategoryId?: string
    category?: ServiceCategoryEntity
    stockType: 'quantity' | 'minute' | 'hour'
    // campos exclusivos de type=consumable (produto consumido internamente via agenda)
    consumptionMode?: 'discrete' | 'fractional'
    deductFromAttendantComission?: boolean
    nominalVolume?: number
    volumeUnit?: string
}
